import React, { MouseEventHandler } from 'react';

interface Props {
    onClick?: MouseEventHandler;
}

const ContactsButton = ({ onClick }: Props) => (
    <div className="contacts-button" onClick={onClick}>
        <svg
            width="48"
            height="48"
            viewBox="0 0 61 62"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
        >
            <defs>
                <path
                    d="M1.836 22.5C.672 22.5 0 22.448 0 21.279s.791-2.994 2.107-3.33c.86-.219 1.809-.391 2.842-.807 1.034-.417 1.186-.83 1.186-1.062 0-.669-.05-.985-1.172-1.673-1.121-.687-.936-2.532-.936-2.844 0-.312-1.33-.636-1.33-1.786s.822-.888.822-1.58c0-.692-.574-1.033-.574-2.304s.839-2.798 1.626-3.099c.787-.3.426.489.53-.651.003-.038-.337.612.018-.11.356-.72 3.029-.792 5.141-1.758 2.186-.998 2.714 1.007 3.285 1.455.571.449-.33-.03.97.763 1.299.793.854 1.28.854 2.619 0 1.339-.706 3.352-.706 3.352s.894.37.706 1.578c-.188 1.208-1.008 1.079-1.008 1.681 0 .367-.195 1.962-.885 2.428-.69.465-1.004.955-1.004 1.536 0 1.481.35 1.143 1.004 1.455.654.311 2.259.497 3.434.807 1.576.417 2.18 4.119 2.18 4.191 0 .25-2.136.36-2.99.36H1.835z"
                    id="a"
                />
            </defs>
            <g fill="none" fillRule="evenodd" className="contacts-button__icon">
                <path
                    d="M30.088 61c16.065 0 29.089-13.431 29.089-30 0-16.569-13.024-30-29.089-30C14.023 1 1 14.431 1 31c0 16.569 13.023 30 29.088 30z"
                    stroke="#CCC"
                    strokeWidth="2"
                    fill="#FFF"
                    strokeDasharray="4,4"
                />
                <g transform="translate(16.18 21.75)">
                    <path d="M5 0h21.816v22.5H5z" />
                    <use className="contacts-button__icon-person" fill="#555" xlinkHref="#a" />
                </g>
                <path
                    className="contacts-button__icon-plus"
                    d="M34.78 19.177c.16-.069 3.5.166 3.795.142.296-.024.637.134.662-.434.025-.569-.12-4.226.04-4.25.158-.023 1.27.042 1.361.087.09.045.052 3.748.051 4.112-.001.363-.048.453.474.428.523-.024 3.908-.105 4.044-.015.136.09.11 1.294-.004 1.408-.114.114-4 .061-4.204.04-.204-.022-.454-.044-.367.457.088.5.055 3.883.029 4.045-.026.162-1.252.257-1.365.097-.114-.16-.033-3.59-.03-4.045.001-.454-.225-.59-.566-.565-.341.024-3.81.104-3.924-.01-.113-.112-.155-1.428.004-1.497z"
                    fill="#555"
                />
            </g>
        </svg>
    </div>
);

export default ContactsButton;
